import React from 'react'
import "../styles/Contact.scss";
const contact = () => {
  return (
    <div className='contact'>
      <main>
        <h1> Contact Us</h1>
        <form >
          <div>
            <label >Name</label>
            <input type="text" required placeholder='Abc' />
          </div>

          <div>
            <label >Email</label>
            <input type="email" required placeholder='Abc@kriss.com' />
          </div>

          <div className='message'>
            <label >Message</label>

            <input type="textarea" className='message_value' required placeholder='Describe your query' />

          </div>
          <div className='button'>
            <button type='submit' id='send'>Aks us</button>
            <button type='reset' id='clear'>Clear</button>
          </div>
        </form>
      </main>
    </div>
  )
}

export default contact